import { render, staticRenderFns } from "./DistrictArea.vue?vue&type=template&id=40f43079&scoped=true&"
import script from "./DistrictArea.vue?vue&type=script&lang=js&"
export * from "./DistrictArea.vue?vue&type=script&lang=js&"
import style0 from "./DistrictArea.vue?vue&type=style&index=0&id=40f43079&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f43079",
  null
  
)

export default component.exports